import type { KioskSettlement } from './types';

export const SETTLEMENT_OUTCOMES = ['ok', 'failed', 'interrupted'] as const;
export const SETTLEMENT_FILTER_KEYS = ['siteId', 'kioskId', 'outcome', 'from', 'to'] as const;

type Translate = (key: string, options?: any) => string;

const when = (iso: string) => new Date(iso).toLocaleString();
const signedCount = (value: number) => (value > 0 ? `+${value}` : `${value}`);
const signedMoney = (value: number) => (value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2));

export function figuresLabel(count: number | null, total: number | null, translate: Translate): string {
  if (count === null || total === null) return '-';
  return translate('resources.kiosk-settlements.figures', { count, total: total.toFixed(2) });
}

export function differenceLabel(record: Pick<KioskSettlement, 'matched' | 'deductCountDifference' | 'deductTotalDifference' | 'addValueCountDifference' | 'addValueTotalDifference'>, translate: Translate): string {
  if (record.matched === null) return '-';
  const { deductCountDifference, deductTotalDifference, addValueCountDifference, addValueTotalDifference } = record;
  if (deductCountDifference === null || deductTotalDifference === null || addValueCountDifference === null || addValueTotalDifference === null) {
    return translate('resources.kiosk-settlements.readerMissing');
  }
  return translate('resources.kiosk-settlements.differenceLine', {
    deducts: signedCount(deductCountDifference),
    deductTotal: signedMoney(deductTotalDifference),
    refunds: signedCount(addValueCountDifference),
    refundTotal: signedMoney(addValueTotalDifference),
  });
}

export function windowLabel(record: Pick<KioskSettlement, 'windowStart' | 'windowEnd'>, translate: Translate): string {
  if (record.windowEnd === null) return '-';
  if (record.windowStart === null) return translate('resources.kiosk-settlements.window.fromStart', { end: when(record.windowEnd) });
  return translate('resources.kiosk-settlements.window.since', { start: when(record.windowStart), end: when(record.windowEnd) });
}

export function settlementRowSx(record: Pick<KioskSettlement, 'matched'>): Record<string, string> {
  return record.matched === false ? { backgroundColor: 'rgba(211, 47, 47, 0.08)' } : {};
}

export function settlementExportQuery(filter: Record<string, unknown>): string {
  const params = new URLSearchParams();
  for (const key of SETTLEMENT_FILTER_KEYS) {
    const value = filter[key];
    if (typeof value === 'string' && value.trim() !== '') params.set(key, value.trim());
  }
  const query = params.toString();
  return query === '' ? '' : `?${query}`;
}
